import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { API_URL } from "..";
import { Spinner } from "react-bootstrap";
import ViewPurchaseBillLayer from "../components/ViewPurchaseBillLayer";

const ViewPurchaseBillPage = () => {
  const { id } = useParams();
  const [bill, setBill] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchBill = async () => {
    try {
      const response = await fetch(`${API_URL}/api/purchase-bills/single/${id}`);
      const data = await response.json();
      setBill(data.data);
    } catch (error) {
      console.error("Error fetching bill:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBill();
  }, [id]);

  return (
    <MasterLayout>
      <Breadcrumb title="View Purchase Bill" />
      {loading && (
        <div className="text-center mt-4">
          <Spinner />
        </div>
      )}
      {!loading && !bill && (
        <div className="text-center mt-4">
          <p>Bill not found.</p>
          <Link to="/purchase-bills" className="btn btn-secondary mt-2">
            Back to List
          </Link>
        </div>
      )}
      {!loading && bill && <ViewPurchaseBillLayer bill={bill} />}
    </MasterLayout>
  );
};

export default ViewPurchaseBillPage;
